import axios from 'axios';

/**
 * Backend base URL without /api. Empty string = same origin (relative /api).
 * Ignores a baked-in localhost URL when the app is opened on a real host (fixes prod builds that wrongly embed .env dev URL).
 */
function resolveApiBase() {
  let base = process.env.REACT_APP_BACKEND_URL;
  if (base == null || base === 'undefined') base = '';
  base = String(base).trim().replace(/\/+$/, '');
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    const pointsToLoopback = /localhost|127\.0\.0\.1/i.test(base);
    if (pointsToLoopback && h !== 'localhost' && h !== '127.0.0.1') {
      base = '';
    }
  }
  return base;
}

const API_BASE = resolveApiBase();
const API = API_BASE ? `${API_BASE}/api` : '/api';

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isAuthEndpoint = requestUrl.includes('/auth/login') || requestUrl.includes('/auth/register');

    if (!isAuthEndpoint) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      if (error.response?.status === 403 && error.response?.data?.detail === 'Not authenticated') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/** Human-readable message for toast (FastAPI detail string, list, or network errors). */
export function formatApiError(error, fallback = 'Permintaan gagal') {
  const d = error.response?.data?.detail;
  if (Array.isArray(d)) {
    return d.map((x) => (typeof x === 'object' && x?.msg ? x.msg : JSON.stringify(x))).join('; ') || fallback;
  }
  if (typeof d === 'string' && d.trim()) return d;
  if (d != null && typeof d === 'object') return JSON.stringify(d);
  if (!error.response) {
    return 'Tidak terhubung ke server. Pastikan Anda membuka dashboard dari domain yang benar (bukan build yang mengarah ke localhost).';
  }
  const st = error.response.status;
  return st ? `${fallback} (HTTP ${st})` : fallback;
}

export default api;
export { API_BASE, API };
